"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _Presence = _interopRequireDefault(require("composer-lib/data/model/Presence"));

var parseLockerIdFromError = function parseLockerIdFromError(error) {
  if (!error) {
    return null;
  }

  var parsedError = JSON.parse(error);

  if (!(parsedError && parsedError.errorTokens && parsedError.errorTokens.lockedBy)) {
    return null;
  }

  return parseInt(parsedError.errorTokens.lockedBy[0], 10);
};

var handleLockFailure = function handleLockFailure(state, _ref) {
  var errorData = _ref.data;
  var newLocker = parseLockerIdFromError(errorData);

  if (!newLocker) {
    return state;
  }

  return state.merge({
    commenters: state.commenters.delete(newLocker),
    locker: newLocker
  });
};

var handleLockUpdate = function handleLockUpdate(state, userId, data) {
  var newLocker = data.payload.lockedBy;
  var oldLocker = state.locker;
  var newCommenters = state.commenters.delete(data.payload.lockedBy);
  var isOldLockerCurrentUserOrNewLocker = oldLocker && [userId, newLocker].includes(oldLocker);

  if (!isOldLockerCurrentUserOrNewLocker) {
    newCommenters = newCommenters.add(oldLocker);
  }

  var isOldLockerCurrentUser = oldLocker === userId;
  var isOldLockerNewLocker = oldLocker === newLocker;
  var accessPassedToast = null;

  if (isOldLockerCurrentUser && !isOldLockerNewLocker) {
    accessPassedToast = newLocker;
  }

  return state.merge({
    accessPassedToast: accessPassedToast,
    commenters: newCommenters,
    locker: newLocker,
    requestedAccess: false,
    requesters: state.requesters.clear(),
    requestRejected: false
  });
};

var handleAddUser = function handleAddUser(state, _ref2) {
  var member = _ref2.member,
      currentUser = _ref2.currentUser;
  var commenters = state.commenters,
      locker = state.locker;
  var userId = parseInt(member.clientId, 10);

  if (!userId) {
    return state;
  }

  if (![locker, currentUser].includes(userId)) {
    return state.merge({
      commenters: commenters.add(userId)
    });
  }

  return state;
};

var handleRemoveUser = function handleRemoveUser(state, _ref3) {
  var member = _ref3.member;
  var commenters = state.commenters,
      requesters = state.requesters;
  var idToRemove = parseInt(member.clientId, 10);

  if (!idToRemove) {
    return state;
  }

  return state.merge({
    commenters: commenters.delete(idToRemove),
    requesters: requesters.delete(idToRemove)
  });
};

var handleLockRequestRejection = function handleLockRequestRejection(state, userId, data) {
  var requestedAccess = state.requestedAccess,
      requesters = state.requesters;
  var rejectedId = data.payload;
  var isCurrentUserBeingRejected = rejectedId === userId;
  return state.merge({
    requesters: requesters.remove(rejectedId),
    requestedAccess: requestedAccess && !isCurrentUserBeingRejected,
    requestRejected: isCurrentUserBeingRejected
  });
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Presence.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var data = action.data;

  switch (action.type) {
    case _ActionTypes.default.ACQUIRE_LOCK_SUCCEEDED:
      return state.set('locker', data.lockedBy);

    case _ActionTypes.default.ACQUIRE_LOCK_FAILED:
    case _ActionTypes.default.SAVE_COMPOSITION_FAILED_BECAUSE_OF_LOCK:
      return handleLockFailure(state, data);

    case _ActionTypes.default.REALTIME_UPDATE_LOCK:
      return handleLockUpdate(state, data.id, data.data);

    case _ActionTypes.default.REALTIME_ADD_USER:
      return handleAddUser(state, data);

    case _ActionTypes.default.REALTIME_REMOVE_USER:
      return handleRemoveUser(state, data);

    case _ActionTypes.default.REALTIME_UPDATE_LOCK_REQUEST:
      return state.set('requesters', state.requesters.add(data));

    case _ActionTypes.default.PASS_LOCK_REQUEST:
      return state.remove('accessPassedToast');

    case _ActionTypes.default.REQUEST_LOCK_SUCCEEDED:
      return state.set('requestedAccess', true);

    case _ActionTypes.default.REALTIME_UPDATE_LOCK_REQUEST_REJECTED:
      return handleLockRequestRejection(state, data.userId, data.data);

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;